import styled from 'styled-components';

export const Container = styled.div`
  margin: 2px 0;
`;

export const VariationsList = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2px;
`;

export const Variation = styled.div`
  position: relative;
  border: 1px solid #d7d7d7;
  cursor: pointer;
  border-radius: 4px;
  opacity: 0.4;
  width: calc(100% / 5);
  padding: 5px;

  &.active,
  &:hover {
    opacity: 1;
    padding: 4px;
    border: 2px solid var(--color-gold);
  }

  img {
    width: 100%;
    margin-bottom: -4px;
    /* height: 120px; */
  }

  p {
    zoom: 0.6;
    position: absolute;
    bottom: 10px;
    left: 10px;
    margin: 0;
    font-weight: bold;
    text-transform: uppercase;
  }
`;
